import React from 'react';
import { Flex, Image, useColorModeValue } from '@chakra-ui/react';
import { HSeparator } from 'components/separator/Separator';
export function SidebarBrand({ collapse }) {
  let logoColor = useColorModeValue('navy.700', 'white');

  return (
    <Flex align="center" direction="column">
      <Image
        src="/logo.png"
        alt="Electropathy Logo"
        mx="auto"
        maxH={collapse ? "40px" : "120px"}
        padding="10px"
        transition="all 0.3s"
      />

      <HSeparator mb="20px" w={collapse ? "40px" : "100%"} />
    </Flex>
  );
}

export default SidebarBrand;
